import { Component } from '@angular/core';
import { AlertController } from 'ionic-angular';
import { NotificationService } from "../../services/notification.service";

@Component({
  selector: 'page-notifications',
  templateUrl: 'notifications.html',
})
export class NotificationsPage {

  public data = [];

  constructor(
    public service: NotificationService,
    public alertCtrl: AlertController
  ) {
  }

  public openNotification(notification){
    this.alertCtrl.create({
      message: notification.list_title,
      buttons: ['OK']
    }).present();
  }

  public deleteNotification(notification){
    this.service.deleteNotification(notification);
  }

  private load(){
    this.service.load().then(() => {
      this.data = this.service.data;
    });
  }

  public ionViewDidEnter() {
    console.log('ionViewDidLoad NotificationsPage');
    this.load();
  }

}



// WEBPACK FOOTER //
// ./src/pages/notifications/notifications.ts